import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackDiarisedTranscriptViewedSpec,
  trackSpeakerAttributionUpdatedSpec,
  type DiarisedTranscriptViewed,
  type SpeakerAttributionUpdated,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const diarisationEvents: SnowplowEventMap = {
  [TrackingEventName.DiarisedTranscriptViewed]: (props) =>
    trackDiarisedTranscriptViewedSpec(props as DiarisedTranscriptViewed),
  [TrackingEventName.SpeakerAttributionUpdated]: (props) =>
    trackSpeakerAttributionUpdatedSpec(props as SpeakerAttributionUpdated),
};
